import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import CreateProject from './pages/CreateProject';
import AccountsReceivable from './pages/AccountsReceivable';
import ClosedProjects from './pages/ClosedProjects';
import DeadProjects from './pages/DeadProjects';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import CreateCustomer from './pages/CreateCustomer';
import Withdrawals from './pages/Withdrawals';
import ProjectCostOverview from './pages/ProjectCostOverview';
import CommissionsAlerts from './pages/CommissionsAlerts';
import ManagementBonus from './pages/ManagementBonus';
import CommissionOverview from './pages/CommissionOverview';
import PaidCommissions from './pages/PaidCommissions';
import PMBreakdown from './pages/PMBreakdown';
import CommissionReport from './pages/CommissionReport';
import Timeclock from './pages/Timeclock';
import PrintTimeCards from './pages/PrintTimeCards';
import Reports from './pages/Reports';
import Setup from './pages/Setup';
import DedupTools from './pages/DedupTools';
import ProjectTypes from './pages/ProjectTypes';
import UsersEmployees from './pages/UsersEmployees';
import EditUserProfile from './pages/EditUserProfile';
import CreateUserProfile from './pages/CreateUserProfile';
import ProjectExpenses from './pages/ProjectExpenses';
import FranchiseLocations from './pages/FranchiseLocations';
import EditFranchise from './pages/EditFranchise';
import ProjectSources from './pages/ProjectSources';
import SettingsPage from './pages/SettingsPage';
import ImportProjects from './pages/ImportProjects';
import ImportLaborExpenses from './pages/ImportLaborExpenses';
import NormalizeNames from './pages/NormalizeNames';
import Insights from './pages/Insights';
import RepairCustomerIds from './pages/RepairCustomerIds';
import DataHealth from './pages/DataHealth';
import MapView from './pages/MapView';
import ImportProjectsV2 from './pages/ImportProjectsV2';
import NotFound from './pages/NotFound';
import SetupPassword from './pages/SetupPassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <div className="App">
      <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/new" element={<CreateProject />} />
          <Route path="/projects/:projectId" element={<ProjectDetail />} />
          <Route path="/projects/accounts-receivable" element={<AccountsReceivable />} />
          <Route path="/projects/closed" element={<ClosedProjects />} />
          <Route path="/projects/dead" element={<DeadProjects />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/new" element={<CreateCustomer />} />
          <Route path="/customers/:customerId" element={<CustomerDetail />} />
          <Route path="/withdrawals" element={<Withdrawals />} />
          <Route path="/project-costs" element={<ProjectCostOverview />} />
          <Route path="/commissions-alerts" element={<CommissionsAlerts />} />
          <Route path="/management-bonus" element={<ManagementBonus />} />
          <Route path="/commission-overview" element={<CommissionOverview />} />
          <Route path="/paid-commissions" element={<PaidCommissions />} />
          <Route path="/pm-breakdown" element={<PMBreakdown />} />
          <Route path="/commission-report" element={<CommissionReport />} />
          <Route path="/commission-report/:id" element={<CommissionReport />} />
          <Route path="/timeclock" element={<Timeclock />} />
          <Route path="/print-time-cards" element={<PrintTimeCards />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/setup/project-types" element={<ProjectTypes />} />
          <Route path="/setup/users-employees" element={<UsersEmployees />} />
          <Route path="/setup/users-employees/new" element={<CreateUserProfile />} />
          <Route path="/setup/users-employees/:email" element={<EditUserProfile />} />
          <Route path="/setup/project-expenses" element={<ProjectExpenses />} />
          <Route path="/setup/franchise-locations" element={<FranchiseLocations />} />
          <Route path="/setup/franchise-locations/:number" element={<EditFranchise />} />
          <Route path="/setup/project-sources" element={<ProjectSources />} />
          <Route path="/setup/settings" element={<SettingsPage />} />
          <Route path="/setup/import-projects" element={<ImportProjects />} />
          <Route path="/setup/import-labor-expenses" element={<ImportLaborExpenses />} />
          <Route path="/setup/normalize-names" element={<NormalizeNames />} />
          <Route path="/setup/insights" element={<Insights />} />
          <Route path="/setup/repair-customer-ids" element={<RepairCustomerIds />} />
          <Route path="/setup/data-health" element={<DataHealth />} />
          <Route path="/setup/map" element={<MapView />} />
          <Route path="/setup/dedup-tools" element={<DedupTools />} />
          <Route path="/setup/import-projects-v2" element={<ImportProjectsV2 />} />
          <Route path="/setup-password" element={<SetupPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
      <Toaster />
    </div>
  );
}

export default App;
